<template>
  <div class="expertThinkTank">
    <comHead :tabIndexI="4" :imgSrc="imgSrc" />
    <div class="content-bg">
      <div class="content">
        <el-tabs v-model="selectedType" @tab-click="selectType">
          <el-tab-pane v-for="(item, index) in types" :key="index" :label="item.FullName" :name="item.Value">
          </el-tab-pane>
        </el-tabs>
        <div class="el_input">
          <el-input v-model.trim="quickQuery" placeholder="" />
          <span @click="search">搜索</span>
        </div>
      </div>
    </div>

    <ul class="newContent">
      <li class="dynamic" v-for="(item, index) in list" :key="index">
        <div class="dynamicPhoto">
          <img :src="$urlFile + item.fCover" alt="" />
        </div>
        <div>
          <div class="time">{{ item.fReleaseDate }}</div>
          <div class="title">
            <a target="_blank" :title="item.fTittle" class="titleText" @click="articleDetail(item)">{{ item.fTittle
            }}</a>
          </div>
          <p class="details">{{ item.fSynopsis }}</p>
        </div>
      </li>
    </ul>
    <div class="pagination">
      <el-pagination layout="prev, pager, next" @current-change="pageIndexChange" :current-page.sync="pageIndex"
        :page-size="pageSize" :total="totalCount">
      </el-pagination>
    </div>
    <comFooter />
  </div>
</template>

<script>
import { getCodeLsit, getNewsList } from "../request/api.js";
export default {
  data() {
    return {
      imgSrc: require("../../static/imgs/information/newBanner.jpg"),
      positionID: this.$route.query.positionID,
      types: [],
      list: [],
      pageIndex: 1,
      pageSize: 8,
      totalCount: 0,
      quickQuery: '',
      selectedType: 0,
      searchTitle: ''
    };
  },
  created() {
    this.toTop();
	console.log(11111);
    getCodeLsit({ code: 'NewsType' }).then(data => {
		
      if (data.StatusCode == 200) {
        this.types = data.Result || [];
        if (this.positionID) {
          this.afterLoad();
        } else {
          this.selectedType = this.types[0].Value;
          this.loadList();
        }
      } else
        console.log(data.Msg);
    });
  },
  methods: {
    selectType(tab, event) {
      this.selectedType = tab.name;
      this.resetSearch();
    },
    pageIndexChange(val) {
      this.pageIndex = val;
      this.loadList();
      this.toTop();
    },
    search() {
      this.pageIndex = 1;
      this.searchTitle = this.quickQuery;
      this.loadList();
    },
    resetSearch() {
      this.quickQuery = "";
      this.searchTitle = "";
      this.pageIndex = 1;
      this.pageSize = 8;
      this.loadList();
    },
    loadList() {
      getNewsList({
        PageInfo: {
          PageIndex: this.pageIndex,
          PageSize: this.pageSize
        },
        fTittle: this.searchTitle,
        fClass: this.selectedType
      }).then(data => {
        // console.log(data.Result);
        data.Result.map(item => {
          item.fReleaseDate = item.fReleaseDate.split('T')[0];
        })
        this.list = data.Result;
        this.totalCount = data.TotalCount;
      });
    },
    articleDetail(item) {
      this.$router.push({
        path: "/articleDetail",
        query: {
          id: item.fNewsId,
          typeText: this.types.find(p => p.Value == this.selectedType).FullName
        }
      });
    },
    toTop() {
      const that = this;
      let timer = setTimeout(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearTimeout(timer);
        }
      }, 30);
    },
    afterLoad() {
      let num = Number(this.positionID.substr(-1));
      switch (num) {
        case 1:
          this.selectedType = "1";
          break;
        case 2:
          this.selectedType = "2";
          break;
		default:
		  this.selectedType = "1";
		  break;
      }
      this.loadList();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/style/index.scss";

/deep/ .el-tabs__item.is-active {
  font-size: 1.25rem !important;
  line-height: 1rem !important;
  color: #0055a2 !important;
}

/deep/ .el-tabs__item {
  color: #333 !important;
  font-size: 1rem;
  height: auto;
}

/deep/ .el-tabs__active-bar {
  background: #0c56b0 !important;
}

/deep/ .el-tabs__nav-wrap::after {
  background: none !important;
}

.expertThinkTank {
  background: #fff !important;

  .content-bg {
    background: #f7f7f7 !important;
    padding: 2rem;

    .content {
      width: 62.5vw;
      min-width: 1200px;
      height: auto;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;

      .el_input {
        width: 19.625rem;
        display: flex;
        flex-wrap: nowrap;
        border: 1px solid #0055a2;

        .el-input {
          width: 14.375rem;

          /deep/ .el-input__inner {
            border: none !important;
          }
        }

        span {
          width: 5.25rem;
          height: 2.5rem;
          color: #fff;
          background: #0055a2;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }
    }
  }

  .newContent {
    width: 88.5vw;
    max-width: 1200px;
    height: auto;
    min-height: 200px;
    margin: 2rem auto;

    .dynamic {
      display: flex;
      align-items: center;
      padding: 2.5rem 0;
      border-bottom: 0.0625rem solid #f0f0f0;

      .dynamicPhoto {
        margin-right: 2.5rem;

        img {
          width: 13.75rem;
          height: 10.3125rem;
        }
      }

      .time {
        font-size: 0.875rem;
        color: #999;
        margin-bottom: 1rem;
      }

      .title {
        font-size: 1.625rem;
        color: #333;
        margin-bottom: 1.25rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;

        .titleText {
          color: #333;
        }

        .titleText:hover {
          color: #0c56b0;
        }
      }

      .details {
        font-size: 1rem;
        color: #999;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
    }
  }

  .pagination {
    margin: 3.5rem 0;
    text-align: center;
  }

  .checked {
    color: rgb(181, 54, 81) !important;
    border-bottom: 2px solid rgb(181, 54, 81) !important;
  }
}
@media screen and(max-width: 500px) {
	.expertThinkTank{
		width: 100vw;
		.content-bg{
			padding: 5px;
			.content{
				width: 100vw;
				min-width: auto;
				display: initial;
				.el_input{
						span{
							height: auto;
						}
					}
			}
		}
	}
}
</style>
